<aside class="app-sidenav" [class.app-sidenav--collapsed]="(opened$ | async) === false">
  <nav class="app-sidenav__nav">
    <a
      *ngFor="let item of menuItems$ | async"
      class="app-sidenav__link"
      [routerLink]="item.route"
      routerLinkActive="app-sidenav__link--active"
    >
      <i [class]="item.icon"></i>
      <span class="app-sidenav__label">{{ item.label }}</span>
    </a>
  </nav>

  <button type="button" class="app-sidenav__logout" (click)="signOut()">
    <i class="fa-solid fa-xmark"></i>
    <span class="app-sidenav__label">Sair</span>
  </button>
</aside>
